<template>

	<div class="main-contents">
		
		<div class="tit mb-7-5">
			<span v-if = "projectStart == '2'">수행예정 프로젝트</span>
			<span v-else-if = "projectStart == '3'">수행중인 프로젝트</span>
			<span v-else>수행완료 프로젝트</span>
			<img src="/images/admin/list_shortcut.png" alt="목록가기" @click="$router.go(-1)"/>
			<div class="show-date" @click="projectStart != '4' ? showChange() : ''" :style="projectStart != '4' ? '' : 'pointer-events : none'">
				<div class="list">
					<div class="list-box show">승인여부 : </div> <SelectComp class="ap" tagName="div" type="text" list="Y:승인,N:미승인" v-model="apprYn"/>
				</div>				
			</div>
		</div>
		<!-- <div class="contents-body demand">

			<ProjectInfo :projectSeq="projectSeq" type="104" @goList="$router.go(-1)"/>
		</div> -->

		<div style="display: flex; margin: 0 auto;">
			<div class="contents-body demand">
				<ProjectInfo :projectSeq="projectSeq" type="104" @goList="$router.go(-1)" @prjSideInfo="setPrjSideInfo"/>
			</div>

			<div class="sticky-btn">
				<div class="recruit">
					<div class="btn_blue" @click="goAdmModifyProject()">프로젝트 수정하기</div> 
				</div>

				<div class="state">
					<p><strong>지원현황</strong></p>
					<div>
                        합격<span>{{prjSideInfo.passMberCnt}}명</span>
                    </div>
					<div>
                        불합격<span>{{prjSideInfo.mberCntFail}}명</span>
                    </div>
					<div>
                        인터뷰<span>{{prjSideInfo.mberCntInterview}}명</span>
                    </div>
					<div>
                        투입<span>{{prjSideInfo.inputMberCnt}}명</span>
                    </div>
				</div>

				<div class="deadline flex-col px-0 py-0" v-if="prjSideInfo.recrCloseYn == 'N'">
					<div>
						<span class="date">
							<img src="/images/tec/prj/date_color.png" alt="마감기간"/> 
							마감 <span class="period">{{prjSideInfo.recrEndDateDiff}}</span> 일 전
						</span>
					</div>
				</div>

				<div class="management"> 					
					<div class="manager flex flex-col">
						<span v-if="prjSideInfo.admMgrMberNm">
							담당 매니저 <strong>{{prjSideInfo.admMgrMberNm}}</strong>
						</span>
						
						<span v-else>
							담당 매니저 <strong>-</strong>
						</span>
						
						<template v-if="$store.state.userInfo.mberDivCd == '00'">
							<a v-if="prjSideInfo.admMgrMberNm" @click="clickChangeAgent('mod')">매니저 변경하기 &gt;</a>
							<a v-else @click="clickChangeAgent('new')">매니저 배정하기 &gt;</a>
						</template>

						<!-- <span >
							<a href="javascript:void(0);">매니저 변경하기 &gt;</a>
						</span> -->
					</div>
				</div>
			</div>
		</div>

	</div>

</template>

<script>

import ProjectInfo from '@/components/highpro/ProjectInfo.vue';

export default {

	components : {
		ProjectInfo
	},

	data() {
		return {
			projectSeq : 0,
			apprYn : '',
			projectStart : '',
			prjSideInfo : {},
		};
	},
	beforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');

		if(this.$route.query.projectSeq != undefined && this.$route.query.projectSeq != '') {
			this.projectSeq = Number(this.$route.query.projectSeq);
		}		
		this.getProjectAppr();
	},
	mounted() {
		// console.log('mounted');
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		getProjectAppr() {
			var param = {
				projectSeq : this.projectSeq
			}
			this.$.httpPost('/api/prj/adm/getProjectAppr', param)
				.then(res => {
					//console.log('getProjectAppr RESULT', res);
					this.apprYn = res.data.apprYn == 'N' ? 'N' : 'Y';
					this.projectNm = res.data.projectNm;
					this.projectStart = res.data.projectStart;
				}).catch(this.$.httpErrorCommon);
		},

		showChange() {
			var params = {
				projectSeq : this.projectSeq,
				projectNm : this.projectNm,
				apprYn : this.apprYn,
			}
				
			this.$.popup('/adm/prj/PRJ911P06', params)
				.then(res => {
					if(res) {
						this.$router.go(0);
					}
				});

		},

		setPrjSideInfo(prjSideData) {
			this.prjSideInfo = prjSideData;
		},

		clickChangeAgent(gubun) {
           
           var params = {

				projectSeq : this.prjSideInfo.projectSeq,
				projectNm : this.prjSideInfo.projectNm,
                currAdmMgrMberSeq : this.prjSideInfo.admMgrMberSeq,
                currAdmMgrMberNm : this.prjSideInfo.admMgrMberNm,
                currAdmMgrLoginId : this.prjSideInfo.admMgrLoginId,
				gubun : gubun,

				caller : {
					name: this.$route.name,
					params: this.input
				}
			}

			this.$router.push({name: 'PRJ910M06', params });
           
        },

		// 관리자의 프로젝트 수정
        goAdmModifyProject() {
            if(!this.editable) return;
            var params = {
				caller : {
					name: this.$route.name,
					params: this.prjSideInfo
				}
			}

            this.$router.push({name: 'PRJ910M03', query : {projectSeq : this.projectSeq}, params });
        },
	},
	computed: {
        editable(){
            return this.$store.state.userInfo.mberDivCd == '00'                             //총괄관리자
                || this.$store.state.userInfo.mberSeq == this.projectInfo.admMgrMberSeq     //담당매니저
        },

    }
};
</script>
